import { getUser } from '@/common/auth'
import { getValueFromQuery } from '@/common/tools'
import { parseJSONSafely } from '@emqx/shared-ui-utils'

export const getDomainUrl = (): string => {
  const url = window.location.origin
  return url
}
export const setPageTitle = (title: string): void => {
  document.title = title
}
export function setFavicon(iconUrl: string): void {
  const favicon = document.getElementById('dynamic-favicon')
  if (favicon) {
    favicon.setAttribute('href', iconUrl)
  } else {
    const newFavicon = document.createElement('link')
    newFavicon.id = 'dynamic-favicon'
    newFavicon.rel = 'icon'
    newFavicon.href = iconUrl
    document.head.appendChild(newFavicon)
  }
}
export const getLang = (): string => {
  const langFromQuery = getValueFromQuery('lang')
  if (langFromQuery && /en|zh_cn|zhhant/i.test(langFromQuery)) {
    return langFromQuery
  }
  let lang = localStorage.getItem('language')
  if (!lang) {
    lang = navigator.language.startsWith('zh_cn') ? 'zh_cn' : 'en'
    localStorage.setItem('language', lang)
  }
  return lang
}

export const getTheme = () => {
  const theme = localStorage.getItem('theme')
  if (theme && ['light', 'dark'].includes(theme)) {
    return theme
  }
  return 'light'
}

export const getSyncOSTheme = (): boolean => {
  const syncOsTheme = localStorage.getItem('syncOsTheme') || 'true'
  if (syncOsTheme === 'undefined') {
    return true
  }
  return JSON.parse(syncOsTheme)
}

export const getLeftBarCollapse = (): boolean => {
  const leftBarCollapse = localStorage.getItem('leftBarCollapse') || 'true'
  if (leftBarCollapse === 'undefined') {
    return true
  }
  return JSON.parse(leftBarCollapse)
}

export const getLoginBackend = (): string => {
  const loginBackend = localStorage.getItem('loginBackend') || 'local'
  if (loginBackend === 'undefined') {
    return 'local'
  }
  return loginBackend
}
export const getMenus = () => {
  const menuList = localStorage.getItem('menus')
  if (menuList === 'undefined') {
    return []
  }
  return parseJSONSafely(menuList)
}

// export const checkMenuTitle = (menu: any, key: string): boolean => {
//   if (menu?.title === key) {
//     return true
//   }
//   if (menu.children) {
//     for (const child of menu.children) {
//       if (checkMenuTitle(child, key)) {
//         return true
//       }
//     }
//   }
//   return false
// }

export const checkMenuTitle = (menu: any, key: string): boolean => {
  const visited = new Set()
  const stack = [menu]

  while (stack.length > 0) {
    const current = stack.pop()
    if (!current || visited.has(current)) {
      continue
    }
    visited.add(current)

    if (current.title === key) {
      return true
    }
    if (current.children) {
      stack.push(...current.children)
    }
  }
  return false
}
const menuCache = new Map<string, boolean>()
export const checkMenuShow = (key: string): boolean => {
  if (menuCache.has(key)) {
    return menuCache.get(key) || false
  }
  const user = getUser()
  if (!user) {
    menuCache.set(key, false)
    return false
  }
  if (user.role === '1') {
    menuCache.set(key, true)
    return true
  }
  const result = checkMenuTitle({ children: getMenus() }, key)
  menuCache.set(key, result)

  return result
}

export const clearMenuCache = () => {
  menuCache.clear()
}
// export const checkMenuShow = (key: string): boolean => {
//   if (getUser()?.role === '1') {
//     return true
//   }
//   return checkMenuTitle({ children: getMenus() }, key)
// }

export const isInChina = (): boolean => {
  return getUser()?.inChina === true
}

export const isSuperadmin = (): boolean => {
  return getUser()?.role === '1'
}
export const getRoleId = (): any => {
  return getUser()?.role
}
